import { createSelector } from 'reselect'

const getCommunicationSummary = (state: any) => state.questionsDetails

/** A Redux selector to retrieve Questions count
 * @param state - The Redux state
 * @param {Boolean} - Numerical value indicating questions count.
 */

export const selectQuestionsCount = createSelector(
  getCommunicationSummary,
  (data) => data && data.questions ? data.questions : 0
)